import format from 'date-fns/format';

export const healthStatusRed = 'RED';
export const healthStatusYellow = 'YELLOW';
export const healthStatusGreen = 'GREEN';
export const healthStatusUnknown = 'UNKNOWN';
export const dateFormat = 'MM/DD/YYYY HH:mm';

export const healthStatusRedBorder = {
  boxShadow: '0 0px 20px 0 #F75E5E',
  border: '2px solid #F75E5E'
};
export const healthStatusYellowBorder = {
  boxShadow: '0 0px 20px 0 #F7CE5E',
  border: '2px solid #F7CE5E'
};
export const healthStatusGreenBorder = {
  boxShadow: '0 0px 20px 0 #78E08B',
  border: '2px solid #78E08B'
};

export const computeHealthPriority = healthStatus => {
  if (healthStatus === healthStatusRed) return 0;
  if (healthStatus === healthStatusYellow) return 1;
  if (healthStatus === healthStatusGreen) return 2;
  if (healthStatus === healthStatusUnknown) return 3;
  return 3;
};

export const formatDate = (date, dateFormat) => {
  if (date) {
    return format(date, dateFormat);
  }
  return '';
};

/***
 * This is done to return border for health boxes on status page, if any of the assets have red health,
 * then border would be red else if any of the assets have yellow health then
 * border would be yellow else when all assets have green dot then border would be green
 */
export const computeHealthBoxBorderColor = healthStatusCount => {
  if (healthStatusCount[healthStatusRed] > 0) {
    return healthStatusRedBorder;
  } else if (healthStatusCount[healthStatusYellow] > 0) {
    return healthStatusYellowBorder;
  } else if (healthStatusCount[healthStatusGreen] > 0) {
    return healthStatusGreenBorder;
  }
};



// WEBPACK FOOTER //
// ./src/models/status/utils.js